import moment from 'moment'
const CHANGE = 'date_change'
let ts = +new Date() - 86400000
let date = new Date(ts)

export function datePicker (
  state = {
    date: moment(date).format('YYYY-MM-DD'),
    dateS: moment(date).format('YYMMDD')
  },
  action
) {
  switch (action.type) {
    case CHANGE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}

export function changeDate (data) {
  return { type: CHANGE, payload: data }
}
